import { ChannelsProps } from './Types'
import { useMemo } from 'react'
import { BrandPlanTactic } from 'types'
import { Text } from 'blaze-ui/Text/Text'

const TacticChannel: Record<BrandPlanTactic, string> = {
  [BrandPlanTactic.Instagram]: 'Instagram',
  [BrandPlanTactic.InstagramReel]: 'Instagram',
  [BrandPlanTactic.Facebook]: 'Facebook',
  [BrandPlanTactic.LinkedIn]: 'LinkedIn',
  [BrandPlanTactic.Twitter]: 'X / Twitter',
  [BrandPlanTactic.SEO]: 'Blogpost',
  [BrandPlanTactic.Email]: 'Email Newsletter',
  [BrandPlanTactic.YouTube]: 'Youtube',
  [BrandPlanTactic.TikTok]: 'Tiktok',
  [BrandPlanTactic.MetaAds]: 'Meta Ads',
  [BrandPlanTactic.GoogleBusinessProfile]: 'Google Business Profile',
}

const VideoTactics = [BrandPlanTactic.TikTok, BrandPlanTactic.YouTube, BrandPlanTactic.InstagramReel]

const SocialTactics = [
  BrandPlanTactic.Instagram,
  BrandPlanTactic.Facebook,
  BrandPlanTactic.LinkedIn,
  BrandPlanTactic.Twitter,
]

export const Channels = ({ campaign }: ChannelsProps) => {
  const {
    crosspost_contents = [],
    video_crosspost_contents = [],
    tactics = [],
    instagram_contents = [],
    facebook_contents = [],
    youtube_contents = [],
    tiktok_contents = [],
    twitter_contents = [],
    linkedin_contents = [],
    seo_contents = [],
    email_contents = [],
  } = campaign

  const channels = useMemo(() => {
    const channels = new Set<string>([])

    const instagramCount = instagram_contents.reduce((sum, item) => sum + item.count, 0)
    const facebookCount = facebook_contents.reduce((sum, item) => sum + item.count, 0)
    const twitterCount = twitter_contents.reduce((sum, item) => sum + item.count, 0)
    const linkedinCount = linkedin_contents.reduce((sum, item) => sum + item.count, 0)
    const youtubeCount = youtube_contents.reduce((sum, item) => sum + item.count, 0)
    const tiktokCount = tiktok_contents.reduce((sum, item) => sum + item.count, 0)
    const seoCount = seo_contents.reduce((sum, item) => sum + item.count, 0)
    const emailCount = email_contents.reduce((sum, item) => sum + item.count, 0)
    const crosspostCount = crosspost_contents.reduce((sum, item) => sum + item.count, 0)
    const videoCrosspostCount = video_crosspost_contents.reduce((sum, item) => sum + item.count, 0)

    if (crosspostCount > 0) {
      const crosspostTactics = tactics.filter((tactic) => SocialTactics.includes(tactic))
      crosspostTactics.forEach((tactic) => {
        channels.add(TacticChannel[tactic])
      })
    }

    if (videoCrosspostCount > 0) {
      const videoCrosspostTactics = tactics.filter((tactic) => VideoTactics.includes(tactic))
      videoCrosspostTactics.forEach((tactic) => {
        channels.add(TacticChannel[tactic])
      })
    }

    if (seoCount > 0) {
      channels.add(TacticChannel[BrandPlanTactic.SEO])
    }

    if (emailCount > 0) {
      channels.add(TacticChannel[BrandPlanTactic.Email])
    }

    if (instagramCount > 0) {
      channels.add(TacticChannel[BrandPlanTactic.Instagram])
    }

    if (facebookCount > 0) {
      channels.add(TacticChannel[BrandPlanTactic.Facebook])
    }

    if (twitterCount > 0) {
      channels.add(TacticChannel[BrandPlanTactic.Twitter])
    }

    if (linkedinCount > 0) {
      channels.add(TacticChannel[BrandPlanTactic.LinkedIn])
    }

    if (youtubeCount > 0) {
      channels.add(TacticChannel[BrandPlanTactic.YouTube])
    }

    if (tiktokCount > 0) {
      channels.add(TacticChannel[BrandPlanTactic.TikTok])
    }

    return channels
  }, [
    crosspost_contents,
    video_crosspost_contents,
    tactics,
    instagram_contents,
    facebook_contents,
    youtube_contents,
    tiktok_contents,
    twitter_contents,
    linkedin_contents,
    seo_contents,
    email_contents,
  ])

  if (channels.size > 3) {
    return <Text>{channels.size} Channels</Text>
  }

  if (channels.size === 1) {
    return <Text>{[...channels][0]}</Text>
  }

  return <Text>{[...channels].join(', ')}</Text>
}
